goog.provide('el8.appshared.formulary');

el8.appshared.formulary = (function() {

    var cache = {};

    // Compute cache key
    function getKey(patientId, medicationId) {
        return patientId+'_'+medicationId;
    }

    return {

        lookup: function(patientId, medicationId, callbackFn) {
            
            var key = getKey(patientId, medicationId);
            if (cache[key]) {
                if (callbackFn) { callbackFn(cache[key]); }
                return;
            }

            $.el8_ajax({
                type: 'GET',
                url: '/patient/'+patientId+'/formulary-status/medication/'+medicationId+'/',
                success: function(data) {
                    cache[key] = data;
                    if (callbackFn) { callbackFn(data); }
                }
            });
        }
    };

})();
